const typeConstant = {
  DESIGN: 'design',
  FITOUT: 'fitout',
  CATEGORY: 'category',
  PROJECT: 'project',
  CITY: 'city',
  BLOG: 'blog',
  NEWS: 'news',
  TEAM: 'team',
  SERVICES: 'services',
  TESTIMONIAL: 'testimonial',
  VIDEO: 'video',
  PAGE: 'page',
  SLIDE: 'slide',
  // FAQ Q&A pairs — question = name/nameAr, answer = content/contentAr,
  // render order = order. Same doc-per-item pattern as slides.
  FAQ: 'faq',
}

module.exports = typeConstant
